export default __webpack_public_path__ + "static/char-v-45-ja-b9d31bbd0c3c14b9124d15ae259d1b02.mp4";